// @ts-nocheck
import { ButtonWrapper } from "@insite/mobius/Button";
import { BreakpointKey } from "@insite/mobius/utilities/breakpointMediaQueries";
import FlexWrapper, { FlexWrapperProps, FlexWrapperStyles } from "@store/Library/Components/Toolkit/FlexWrapper";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import breakpointUtility from "@toolkit/Framework/Common/Utilities/breakpoint";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC, PropsWithChildren, useMemo } from "react";
import { css, useTheme } from "styled-components";

export interface FormActionsProps extends ExpandStyles<FormActionsStyles> {
    fullWidth?: boolean;
    gap?: FlexWrapperProps["gap"];
    verticalGap?: FlexWrapperProps["verticalGap"];
    spacing?: string;
    breakpoint?: BreakpointKey;
}

export interface FormActionsStyles {
    flexWrapper?: FlexWrapperStyles;
}

export const formActionsStyles: FormActionsStyles = {
    flexWrapper: {
        item: {
            css: css`
                width: 100%;

                ${ButtonWrapper},
                > * {
                    width: 100%;
                }
            `,
        },
    },
};

const FormActions: FC<PropsWithChildren<FormActionsProps>> = ({
    children,
    fullWidth,
    extendedStyles,
    overridedStyles,
    ...props
}) => {
    const baseStyles = useExpandProps(formActionsStyles, extendedStyles, overridedStyles);
    const theme = useTheme();

    const breakpoint = props.breakpoint || "sm";
    const gap = props.gap || theme.design.form.actions.gap;
    const verticalGap = props.verticalGap || theme.design.form.actions.verticalGap;
    const spacing = props.spacing || theme.design.form.actions.spacing || null;

    const styles = useMemo(() => {
        return mergeProps<FormActionsStyles>(
            {
                flexWrapper: {
                    wrapper: {
                        css: spacingStyles(spacing, null),
                    },
                    item: {
                        css: css`
                            ${() => {
                                if (!fullWidth) {
                                    return css`
                                        ${breakpointUtility(breakpoint)} {
                                            width: auto;
                                        }
                                    `;
                                }
                            }}
                        `,
                    },
                },
            },
            baseStyles,
        );
    }, [fullWidth, breakpoint, spacing, baseStyles]);

    if (!children) {
        return null;
    }

    return (
        <FlexWrapper gap={gap} verticalGap={verticalGap} extendedStyles={styles.flexWrapper}>
            {children}
        </FlexWrapper>
    );
};

export default FormActions;
